import React, { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useI18n } from "@/i18n/I18nContext";
import api from "@/lib/api";
import { AUTH } from "@/constants/testIds";
import SEO from "@/components/seo/SEO";

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
    } finally {
      setLoading(false);
      setSent(true);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <SEO title="Mot de passe oublié | Kalypso Music" description="Réinitialisez le mot de passe de votre compte Kalypso Music." path="/forgot-password" noindex />
      <div className="w-full max-w-md">
        <Link to="/" className="mb-8 flex items-center justify-center gap-2">
          <img src="/logo.png" alt="Kalypso Music" className="h-10 w-10 rounded-xl object-cover" />
          <span className="font-heading text-xl font-semibold">Kalypso Music</span>
        </Link>

        <div className="rounded-2xl border border-border bg-card p-8">
          {sent ? (
            <div className="text-center">
              <CheckCircle2 className="mx-auto h-10 w-10 text-emerald-500" />
              <p className="mt-4 text-sm text-muted-foreground">{t("auth.forgotPasswordSent")}</p>
            </div>
          ) : (
            <>
              <h1 className="font-heading text-2xl font-medium">{t("auth.forgotPasswordTitle")}</h1>
              <p className="mt-1 text-sm text-muted-foreground">{t("auth.forgotPasswordSubtitle")}</p>
              <form onSubmit={handleSubmit} className="mt-6 space-y-4">
                <div>
                  <Label htmlFor="email">{t("auth.emailLabel")}</Label>
                  <Input id="email" type="email" required data-testid={AUTH.forgotPasswordEmail} value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" />
                </div>
                <Button type="submit" className="w-full rounded-full" data-testid={AUTH.forgotPasswordSubmit} disabled={loading}>
                  {loading ? t("common.loading") : t("auth.forgotPasswordSubmit")}
                </Button>
              </form>
            </>
          )}
          <p className="mt-6 text-center text-sm text-muted-foreground">
            <Link to="/login" className="font-medium text-primary hover:underline">
              {t("auth.backToLogin")}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
